var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show)?_c('div',{staticClass:"ToastMessage",class:_vm.getClass},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }